import { Image } from "primereact/image";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import loginBannerImg from "../../../assets/images/login-banner-img.png";
import { alreadyRegistered, selectDialog } from "../../../redux/dialogSlice";
import { setLoading } from "../../../redux/loadingSlice";
import Hero from "../Hero/Hero";
import Services from "../Services/Services";
import Counter from "../../Counter/Counter";
import QuickSteps from "../../QuickSteps/QuickSteps";
import SimpleSlider from "../../SimpleSlider/SimpleSlider";
import FAQ from "../FAQ/FAQ";
import Franchise from "../Franchise/Franchise";
import DownloadApp from "../DownloadApp/DownloadApp";
import PopularProducts from "../PopularProducts/PopularProducts";
import AppSkeleton from "../../AppSkeleton/AppSkeleton";

const PunctureKit = () => {
  const loading = useSelector((state: any) => state.loading);
  const dispatch = useDispatch();
  const visible = useSelector(selectDialog);
  const alreadyRegState = useSelector(alreadyRegistered);

  const headerElement = (
    <div>
      <Image
        src={loginBannerImg}
        alt="Mechmiles Banner"
        className="login-banner-img"
      />
    </div>
  );

  useEffect(() => {
    // window.scrollTo(0, 0);

    dispatch(setLoading(true));
    // Fetch data here...
    // After data is fetched, set loading to false
    setTimeout(() => {
      dispatch(setLoading(false));
    }, 300);
  }, [dispatch]);

  return (
    <>
      {/* {loading && <div className="loading-overlay">Loading...</div>} */}
      {/* {
        loading && (
          <AppSkeleton
            count={1}
            width="100%"
            height="300px"
            borderRadius="12px"
            containerClassName="popular-brands-skeleton-grid"
            className="popular-brands-skeleton-item"
          />
        )
        // <InfiniteLoader />
      } */}
      {/* Add "react-loading-overlay-nextgen" Loader */}
      <div className="home-wrapper">
        <section className="banner-section">
          <Hero code="ACCESSORIES" />
        </section>
        <section className="popular-products-section">
          {/* <PunctureKitProducts /> */}
          <PopularProducts
            code="ACCESSORIES"
            title="Accessories"
            entityType={null}
          />
        </section>
        <section className="services-section">
          <Services />
        </section>
        <section className="counter-section">
          <Counter />
        </section>
        <section className="quick-steps-section">
          <QuickSteps />
        </section>
        <section className="testimonials-section">
          <SimpleSlider />
        </section>
        <section className="faq-section">
          <FAQ />
        </section>
        <section className="franchise-section">
          <Franchise />
        </section>
        <section className="download-app-section">
          <DownloadApp />
        </section>
      </div>
    </>
  );
};

export default PunctureKit;
